module.exports = __webpack_public_path__ + "static/media/sc16.22.aaafb340.mp4";